<ng-container *ngIf="vectoresPago && vectoresPago.length == 0">
    <div class="no-hay-informacion">
        <label>{{'PERFILCREZCAMOS.LBL_NOVECTORESPAGOCRZ' | translate}}</label>
    </div>
</ng-container>
<div *ngIf="vectoresPago && vectoresPago.length > 0">
    <p-table [value]="vectoresPago" class="tabla-vectores">
        <ng-template pTemplate="header">
            <tr>
                <th colspan="7">{{ 'PERFILCREZCAMOS.LBL_ULTIMOS6VECTORESPAGOCRZ' | translate }}</th>
            </tr>
            <tr>
                <th></th>
                <th *ngFor="let title of arrayTitleColumns">{{ title }}</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-pago>
            <tr>
                <td class="role">{{ pago.rol }}</td>
                <td>{{ pago.v1 }}</td>
                <td>{{ pago.v2 }}</td>
                <td>{{ pago.v3 }}</td>
                <td>{{ pago.v4 }}</td>
                <td>{{ pago.v5 }}</td>
                <td>{{ pago.ult }}</td>
            </tr>
        </ng-template>
    </p-table>
</div>
